import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs'
import EmailContactList from './EmailContactList';
import WhatsAppContactList from './WhatsAppContactList';
import SMSContactList from './SMSContactList';
import ManageContactList from './ManageContactList';
import ContactCenterController from '../../../../Controllers/AdminScreens/Configuration/ContactsCenter/ContactsCenterController';


const ContactsCenterScreen = () => {
    const{
         fetchWhatappList,
    whatsappLoading,
    whatsappList,
    whatsappError,
    setWatsappLoading,
    setWatsappError,
    setWhatsappList,

    setEmailError,
    emailError,
    setEmailList,
    emailList,
    emailLoading,
    setEmailLoading,
    fetchEmailList,

    setSmsError,
    smsError,
    setSmsList,
    smsList,
    setSmsLoading,
    smsLoading,
    fetchSMSList,

    listSummaryList,
    setListSummaryList,
    listSummaryError,
    setListSummaryError,
    listSummaryLoading,
    setListSummaryLoading,
    fetchListSummary
    } = ContactCenterController()
    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const handleTabChange = (index) => {
  setSelectedTab(index);

  if (index === 0 && whatsappError) {
    setWatsappError('');
    fetchWhatappList(); // only fetch if error existed
  } else if (index === 1 && emailError) {
    setEmailError('');
    fetchEmailList();
  } else if (index === 2 && smsError) {
    setSmsError('');
    fetchSMSList();
  } else if (index === 3 && listSummaryError) {
    setListSummaryError('');
    fetchListSummary();
  }
};

    const handleRefreshAllTabs = () => {
    fetchWhatappList();
    fetchEmailList();
    fetchSMSList();
    fetchListSummary();
    };

    const tabs = ['Email', 'SMS', 'Manage List'];
    const whatsAppStatus = JSON.parse(localStorage.getItem('whatsAppStatus'));
    if (whatsAppStatus === 1) {
        tabs.unshift('WhatsApp');
    }


    // const {

    // } = InvoiceSettingsController()

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{paddingBottom:10}}>
                <h2 className='title'>Contacts Center</h2>
            </div>

            <div >
              <Tabs tabs={tabs}
                    selectedIndex={selectedTab}
                    onTabChange={handleTabChange}>
                    {tabs.map((tab) => {
                        switch (tab) {
                            case 'WhatsApp':
                                return (
                                    <WhatsAppContactList setWhatsappList={setWhatsappList} whatsappList={whatsappList} whatsappError={whatsappError} setWatsappError={setWatsappError} setWatsappLoading={setWatsappLoading} whatsappLoading={whatsappLoading} onRefresh={fetchWhatappList} handleRefreshAllTabs={handleRefreshAllTabs}/>
                                );
                            case 'Email':
                                return (
                                     <EmailContactList setEmailList={setEmailList} emailList={emailList} emailError={emailError} setEmailError={setEmailError} setEmailLoading={setEmailLoading} emailLoading={emailLoading} onRefresh={fetchEmailList} handleRefreshAllTabs={handleRefreshAllTabs}/>
                                );
                            case 'SMS':
                                return (
                                    <SMSContactList  setSmsList={setSmsList} smsList={smsList} smsError={smsError} setSmsError={setSmsError} setSmsLoading={setSmsLoading} smsLoading={smsLoading} onRefresh={fetchSMSList} handleRefreshAllTabs={handleRefreshAllTabs}/>
                                );
                            case 'Manage List':
                                return (
                                    <ManageContactList listSummaryList={listSummaryList} setListSummaryList={setListSummaryList} listSummaryError={listSummaryError} setListSummaryError={setListSummaryError} listSummaryLoading={listSummaryLoading} setListSummaryLoading={setListSummaryLoading} onRefresh={fetchListSummary} handleRefreshAllTabs={handleRefreshAllTabs}/>
                                );
                            default:
                                return null;
                        }
                    })}
                </Tabs>
            {/* <Tabs tabs={tabs}
            selectedIndex={selectedTab}
            onTabChange={handleTabChange}>
                    <WhatsAppContactList setWhatsappList={setWhatsappList} whatsappList={whatsappList} whatsappError={whatsappError} setWatsappError={setWatsappError} setWatsappLoading={setWatsappLoading} whatsappLoading={whatsappLoading} onRefresh={fetchWhatappList} handleRefreshAllTabs={handleRefreshAllTabs}/>
                    <EmailContactList setEmailList={setEmailList} emailList={emailList} emailError={emailError} setEmailError={setEmailError} setEmailLoading={setEmailLoading} emailLoading={emailLoading} onRefresh={fetchEmailList} handleRefreshAllTabs={handleRefreshAllTabs}/>
                    <SMSContactList  setSmsList={setSmsList} smsList={smsList} smsError={smsError} setSmsError={setSmsError} setSmsLoading={setSmsLoading} smsLoading={smsLoading} onRefresh={fetchSMSList} handleRefreshAllTabs={handleRefreshAllTabs}/>
                    <ManageContactList listSummaryList={listSummaryList} setListSummaryList={setListSummaryList} listSummaryError={listSummaryError} setListSummaryError={setListSummaryError} listSummaryLoading={listSummaryLoading} setListSummaryLoading={setListSummaryLoading} onRefresh={fetchListSummary} handleRefreshAllTabs={handleRefreshAllTabs}/>
                </Tabs> */}
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default ContactsCenterScreen;